import React from "react";
import hero1 from '../../images/slider/hero-3.jpg'
import hero2 from '../../images/slider/hero4-flower.png'
import bg from '../../images/slider/hero-bg22.png'


const Hero4 = () => {
    return (

        <section className="static-hero-s3" style={{ backgroundImage: `url(${bg})` }}>
            <div className="hero-container">
                <div className="hero-inner">
                    <div className="container-fluid">
                        <div className="row align-items-center">
                            <div className="col-xl-6 col-lg-6 col-12">
                                <div className="wpo-static-hero-inner">
                                    <div className="slide-title">
                                        <h2>Mesa <span>de</span> regalos</h2>
                                        <div className="shape"><img src={hero2} alt="" />
                                        </div>
                                    </div>
                                    <div className="clearfix"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="static-hero-right">
                <div className="static-hero-img">
                    <div className="static-hero-img-inner">
                        <img className="zoom" src={hero1} alt="" />
                    </div>
                </div>
                <div className="wpo-wedding-date">
                    <div>
                        <h1 className="how-it-works">¿Cómo funciona?</h1>
                        <h3>1. Explora las categorías:</h3>
                        <p> Algo para nuestra luna de miel o algo para Pamik 🐶</p>

                        <h3>2. Elige tu regalo favorito:</h3>

                        <p>Selecciona un producto o experiencia que te gustaría regalarnos.</p>

                        <h3>3. Llena tus datos:</h3>

                        <p>Y —si quieres— un mensajito para nosotrxs 💌</p>

                        <h3>4. Realiza la transferencia:</h3>

                        <p>Aparecerán nuestros <strong>datos bancarios</strong> para hacer la transferencia a nuestra cuenta compartida.</p>

                        <h3>5. Adjunta tu comprobante:</h3>

                        <p>Sube el archivo del comprobante bancario y ¡listo!</p>

                        <p>Te llegará un mensaje de agradecimiento (y quizás un sticker digital de Pamik 🐶).</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Hero4;